import store from '@/store'
import { AuthTypes } from '@/store/types/auth'
import { sleep } from '@/util'

const meta = {
  layout: 'LegacyLayout',
}
export default [
  {
    path: '/myfunda/schedule/detail/:fNum?',
    name: 'myfunda-schedule-detail',
    meta: {
      layout: 'LegacyLayoutFluid',
    },
    component: () =>
      import(
        /* webpackChunkName: "myfunda-schedule-detail" */ '@/pages/myfunda/schedule-detail/ScheduleDetail.vue'
      ),
    props: true,
  },
  {
    path: '/myfunda/schedule/majungmul-detail/:fNum?',
    name: 'myfunda-majungmul-detail',
    meta: {
      layout: 'LegacyLayoutFluid',
    },
    component: () =>
      import(
        /* webpackChunkName: "myfunda-schedule-detail" */ '@/pages/myfunda/schedule-detail/MajungmulDetail.vue'
      ),
    props: true,
  },
  {
    path: '/myfunda/schedule/fundanow-detail/:fNum?',
    name: 'myfunda-fundanow-detail',
    meta: {
      layout: 'LegacyLayoutFluid',
    },
    component: () =>
      import(
        /* webpackChunkName: "myfunda-schedule-detail" */ '@/pages/myfunda/schedule-detail/FundaNowDetail.vue'
      ),
    props: true,
  },
  {
    path: '/myfunda/schedule/disposals',
    name: 'myfunda-disposals',
    meta: {
      layout: 'LegacyLayoutFluid',
    },
    component: () =>
      import(
        /* webpackChunkName: "myfunda-schedule-detail" */ '@/pages/myfunda/schedule-detail/DisposalDetail.vue'
      ),
    props: true,
  },
  {
    path: '/myfunda',
    component: () =>
      import(
        /* webpackChunkName: "myfunda-shell" */ '@/pages/myfunda/Index.vue'
      ),
    meta,
    beforeEnter: async (to, from, next) => {
      let tryCount = 0
      while (store.getters['auth/getProfileLoading']) {
        tryCount++
        await sleep(500)
        if (tryCount > 100) {
          break
        }
      }

      const profile = store.getters[`auth/${AuthTypes.getters.GET_PROFILE}`]
      if (profile.newBankAccountFunda != null) {
        next()
      } else {
        const uv =
          store.getters[`auth/${AuthTypes.getters.GET_USER_VALIDATION}`]

        let userCdds = uv.userCdds.length > 0 ? uv.userCdds : []

        const isWaiting = userCdds.some(cdd => cdd.status === 'WAITING')

        if (isWaiting === true && uv.userEdds.length > 0) {
          await global.$vm.$swal.basic.alert(
            '본인 인증 완료 후 마이펀다를 이용하실 수 있습니다.'
          )
        } else {
          await global.$vm.$swal.basic.alert('투자자 정보를 입력해주세요.')
          next({ name: 'signup' })
        }
      }
    },
    children: [
      {
        path: 'home',
        alias: '',
        name: 'myfunda-home',
        component: () =>
          import(
            /* webpackChunkName: "myfunda-home" */ '@/pages/myfunda/DashboardHome.vue'
          ),
        meta,
      },
      {
        path: 'invest-board',
        name: 'myfunda-invest-board',
        component: () =>
          import(
            /* webpackChunkName: "myfunda-invest-board" */ '@/pages/myfunda/InvestBoard.vue'
          ),
        meta,
      },
      {
        path: 'invest-list',
        name: 'myfunda-invest-list',
        component: () =>
          import(
            /* webpackChunkName: "myfunda-invest-list" */ '@/pages/myfunda/InvestList.vue'
          ),
        props: true,
        meta,
      },
      {
        path: 'schedule',
        name: 'myfunda-schedule',
        component: () =>
          import(
            /* webpackChunkName: "myfunda-schedule" */ '@/pages/myfunda/Schedule.vue'
          ),
        meta,
      },
      {
        path: 'balance-deposit',
        component: () =>
          import(
            /* webpackChunkName: "myfunda-balance-deposit" */ '@/pages/myfunda/BalanceDepositIndex.vue'
          ),
        meta,
        children: [
          {
            path: '',
            name: 'myfunda-balance-deposit',
            component: () =>
              import(
                /* webpackChunkName: "myfunda-balance-deposit" */ '@/pages/myfunda/balance-deposit/BalanceDepositAccount.vue'
              ),
            meta,
          },
          {
            path: 'transaction',
            name: 'balance-deposit-transaction',
            component: () =>
              import(
                /* webpackChunkName: "myfunda-balance-deposit" */ '@/pages/myfunda/balance-deposit/BalanceDepositTransaction.vue'
              ),
            meta,
          },
          {
            path: 'point',
            name: 'balance-deposit-point',
            component: () =>
              import(
                /* webpackChunkName: "myfunda-balance-deposit" */ '@/pages/myfunda/balance-deposit/BalanceDepositPoint.vue'
              ),
            meta,
          },
        ],
      },
      {
        path: 'setting',
        component: () =>
          import(
            /* webpackChunkName: "myfunda-setting" */ '@/pages/myfunda/SettingIndex.vue'
          ),
        meta,
        children: [
          {
            path: '',
            name: 'myfunda-setting',
            component: () =>
              import(
                /* webpackChunkName: "myfunda-setting" */ '@/pages/myfunda/setting/Normal.vue'
              ),
            meta,
          },
          {
            path: 'investor',
            name: 'myfunda-setting-investor',
            component: () =>
              import(
                /* webpackChunkName: "myfunda-setting" */ '@/pages/myfunda/setting/Investor.vue'
              ),
            meta,
          },
          {
            path: 'login-history',
            name: 'myfunda-setting-login-history',
            component: () =>
              import(
                /* webpackChunkName: "myfunda-setting" */ '@/pages/myfunda/setting/LoginHistory.vue'
              ),
            meta,
            props: route => ({ query: route.query }),
          },
        ],
      },
    ],
  },
]
